{
  "en": {
    "linkShortener": {
      "hints": {
        "copied": "Copied to clipboard!",
        "shortcode": "We generated a random shortcode for you. Set your own here."
      },
      "labels": {
        "shortcode": "Short Link",
        "url": "URL"
      }
    }
  }
}
